<template>
  <VModal
    v-if="displayModal"
    ref="modal"
    :size="modalSize"
    @modal:hidden="$emit('production-order-item-modal:closed')"
  >
    <template #header>
      <div>
        <portal-target name="production-order-item-modal-header" />
      </div>
    </template>
    <template v-if="loading" #default>
      <div class="p-6 text-center">
        <Loader />
      </div>
    </template>
    <template v-else #default>
      <div class="flex">
        <div class="flex-1 p-6 bg-white">
          <div class="space-y-8">
            <ProductionOrderItem :id="id" />
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import ProductionOrderItem from './productionOrderItemModal/ProductionOrderItem.vue';

export default {
  name: 'ProductionOrderItemModal',

  components: {
    ProductionOrderItem,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      displayModal: false,
      modalSize: 'lg',
      loading: false,
      data: {
        id: this.id,
        attributes: {
          title: '',
          content: '',
          due_at: '',
          has_time: '',
        },
      },
    };
  },

  computed: {
    productionOrderItem() {
      return this.$store.state.entities.orderItems.byId[this.id];
    },
  },

  watch: {
    productionOrderItem: {
      deep: true,
      handler(productionOrderItem) {
        if (!productionOrderItem) {
          return;
        }

        const { title, content, dueAt, hasTime } = productionOrderItem;

        this.data.attributes = {
          title,
          content,
          due_at: dueAt,
          has_time: hasTime,
        };
      },
    },
  },

  mounted() {
    this.displayModal = true;
    this.fetchProductionOrderItem();
  },

  methods: {
    async fetchProductionOrderItem() {
      this.loading = true;

      try {
        await this.$store.dispatch({
          type: 'ui/orderItems/read',
          orderItemUuid: this.id,
          params: {
            include: 'media,links,notes',
          },
        });

        this.loading = false;
      } catch (error) {
        this.$refs.modal.toggleModal();
      }
    },
    async update() {
      try {
        await this.$store.dispatch({
          type: 'ui/productionOrderItems/update',
          id: this.data.id,
          body: {
            ...this.data.attributes,
          },
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
